/************************************
	BlueBasis FE Vue Entry File
************************************/
import { Blue } from '!/js/core';
import Vue from 'vue';
import App from '@/matrix/App';
import store from '@/matrix/store';
import router from '@/matrix/router';

import VModal from 'vue-js-modal';

Vue.use(VModal);

Vue.config.devtools = true;
Vue.config.productionTip = false;

const app = new Vue({
	store,
	router,
	render: h => h(App)
});
const util = new Blue({});

util.ready('mount_app', '#app', el => app.$mount(el));


/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/